import { LocalStorage } from 'shared/helpers/localStorage';
import { LOCAL_STORAGE_KEYS } from 'dashboard/constants/localStorage';

const EXTRA_THEME_CLASSES = [
  'theme-gray-soft',
  'theme-sepia-soft',
  'theme-slate-soft',
  'theme-dark-soft',
  'theme-nord-dark',
  'theme-graphite-dark',
];

const clearExtraThemes = () => {
  // Remove classes conhecidas
  document.body.classList.remove(...EXTRA_THEME_CLASSES);

  // Segurança: remove qualquer theme-* que tenha sobrado
  [...document.body.classList].forEach(c => {
    if (c.startsWith('theme-')) document.body.classList.remove(c);
  });
};

const applyExtraTheme = className => {
  if (!className) return;
  document.body.classList.add(className);
};

export const setColorTheme = isOSOnDarkMode => {
  const selectedColorScheme =
    LocalStorage.get(LOCAL_STORAGE_KEYS.COLOR_SCHEME) || 'auto';

  clearExtraThemes();

  // Temas Light extras
  if (selectedColorScheme === 'gray-soft') {
    document.body.classList.remove('dark');
    document.documentElement.style.setProperty('color-scheme', 'light');
    applyExtraTheme('theme-gray-soft');
    return;
  }

  if (selectedColorScheme === 'sepia-soft') {
    document.body.classList.remove('dark');
    document.documentElement.style.setProperty('color-scheme', 'light');
    applyExtraTheme('theme-sepia-soft');
    return;
  }

  if (selectedColorScheme === 'slate-soft') {
    document.body.classList.remove('dark');
    document.documentElement.style.setProperty('color-scheme', 'light');
    applyExtraTheme('theme-slate-soft');
    return;
  }

  // Temas Dark extras (mantém `.dark`)
  if (selectedColorScheme === 'dark-soft') {
    document.body.classList.add('dark');
    document.documentElement.style.setProperty('color-scheme', 'dark');
    applyExtraTheme('theme-dark-soft');
    return;
  }

  if (selectedColorScheme === 'nord-dark') {
    document.body.classList.add('dark');
    document.documentElement.style.setProperty('color-scheme', 'dark');
    applyExtraTheme('theme-nord-dark');
    return;
  }

  if (selectedColorScheme === 'graphite-dark') {
    document.body.classList.add('dark');
    document.documentElement.style.setProperty('color-scheme', 'dark');
    applyExtraTheme('theme-graphite-dark');
    return;
  }

  // Comportamento original (light/dark/auto)
  const shouldUseDarkBase =
    (selectedColorScheme === 'auto' && isOSOnDarkMode) ||
    selectedColorScheme === 'dark';

  if (shouldUseDarkBase) {
    document.body.classList.add('dark');
    document.documentElement.style.setProperty('color-scheme', 'dark');
  } else {
    document.body.classList.remove('dark');
    document.documentElement.style.setProperty('color-scheme', 'light');
  }
};
